export default __webpack_public_path__ + "static/give-back-de398112e5edb0eb5b520dd8ec0b23d8.jpg";